import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from './PeopleFinderPanel.css';
import { NavigatorStore } from '../stores';
import { IAPeopleFinder } from '../../peopleFinder';

export interface IProps {
  navigatorStore?: NavigatorStore;
}

export interface IState { }

@inject('navigatorStore')
@observer
export class PeopleFinderPanel extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    this.state = {
      content: [],
      searchQuery: '',
      isLoading: false,
      hasAllPeople: false,
      loadingMore: false,
    };
  }

  public render() {
    const isPeopleFinderSelected = this.props.navigatorStore.selectedPeopleFinder != undefined;
    const height: number = this.props.navigatorStore.contentHeight;
    let position = {};
    if (this.props.navigatorStore.navigator != undefined && this.props.navigatorStore.navigator.design.menuBar.layout == 'vertical') {
      let top = 0;
      if (this.props.navigatorStore.verticalMenuExpanded) {
        top = this.props.navigatorStore.selectedPeopleFinder != undefined ? 250 : -600;
      } else {
        top = this.props.navigatorStore.selectedPeopleFinder != undefined ? 0 : -600;
      }
      position = {
        top: top,
      };
    } else {
      position = {
        top: isPeopleFinderSelected ? 0 : -height,
      };
    }
    // let top = 40;
    // if (
    //   (Helper.getDisplayEnvironment() === 'Sharepoint' || Helper.getDisplayEnvironment() === 'SharepointClassic') &&
    //   document.getElementById('IA_navigator_bar') != undefined &&
    //   document.getElementById('IA_navigator_vertical_menu') == undefined
    // ) {
    //   top = 88;
    // }
    console.log(position);
    return (
      <div
        id="peopleFinder"
        style={{
          display: isPeopleFinderSelected ? 'block' : 'none',
        }}
      >
        <div
          className={styles.peopleFinderContainer}
          id="peopleFinderContainer"
          style={{
            // top: this.props.navigatorStore.selectedPeopleFinder ? this.props.navigatorStore.contentHeight + top : top,
            height: height,
            // width: this.props.navigatorStore.isMobile ? '100%' : 600,
            ...position,
          }}
        >
          {this.props.navigatorStore.navigator != undefined && this.props.navigatorStore.selectedPeopleFinder && (
            <IAPeopleFinder
              config={this.props.navigatorStore.selectedPeopleFinder}
              onClose={() => {
                this.props.navigatorStore.selectedPeopleFinder = undefined;
                this.props.navigatorStore.selectTopMenuItem(undefined);
                document.body.style.overflowY = 'auto';
                document.body.style.height = 'inherit';
              }}
              design={{
                colors: {
                  mainColor: this.props.navigatorStore.navigator.design.menuBar.backgroundColor,
                  iconColor: '#333', // this.props.navigatorStore.navigator.design.menuBar.iconColor,
                  highlightColor: this.props.navigatorStore.navigator.design.menuBar.highlightColor,
                  highlightTextColor: this.props.navigatorStore.navigator.design.topItems.highlightTextColor, //
                },
              }}
              token={this.props.navigatorStore.token}
              tenant={this.props.navigatorStore.tenant}
              type={'navigator'}
              height={this.props.navigatorStore.contentHeight}
              width={this.props.navigatorStore.width}
              environment={this.props.navigatorStore.environment}
            />
          )}
        </div>
      </div>
    );
  }
}
